<template>
  <span class="created">
    <span class="logoContainer">
      <!-- <img class="logo" alt src="../assets/logoGrey.png" /> -->
      <span class="text">Powered by Orium</span>
    </span>
  </span>
</template>

<script>
export default {
  name: "Created",
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.created {
  float: right;
  height: 30px;
  width: auto;
}

.created .logoContainer {
  color: #9292a8;
  font-family: "SofiaProRegular";
  font-size: 18px;
  letter-spacing: 0;
  line-height: 18px;
  height: 32px;
}

.story .section {
  display: flex;
  justify-content: space-between;
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
text {
  font-family: "SofiaProRegular";
}

@media only screen and (min-width: 375px) and (max-width: 515px) {
  
  .created {
    width: 300px;
    float: left;
    margin-top: 10px;
    margin-left: 5px;
  }

  .created .logoContainer {
    height: 30px;
    width: 100%;
  }
  .text {
    font-size: 14px;
  }

  .created .logoContainer .logo {
    width: 25px;
    height: 25px;
  }
}

@font-face {
  font-family:"SofiaProRegular";
  src:local("SofiaProRegular"),
  url(../fonts/SofiaProRegular.ttf)
  format("truetype")
}

</style>
